import React from "react";
import { Row, Column, FormGroup, Checkbox } from "carbon-components-react";
import useGet from "../../hooks/useGet";
import DynamicCheckbox from "../Checkboxes/DynamicCheckbox";
import {
  checkHasOwnBusiness,
  checkIsEmployed,
  isCandidatureOptionChecked,
  updateCheckedOptions,
} from "../../services/Utils";
import { useEffect } from "react";

const CurrentOccupationForm = ({
  disabled,
  candidature,
  selectedOccupations,
  setSelectedOccupations,
  setHasOwnBusiness,
  setIsEmployed,
}) => {
  const { data: occupations } = useGet("/lookup/occupations");

  const updateOccupations = (id, checked) => {
    setSelectedOccupations(
      updateCheckedOptions(selectedOccupations, id, checked)
    );
  };

  useEffect(() => {
    setHasOwnBusiness(checkHasOwnBusiness(selectedOccupations, 60));
    setIsEmployed(checkIsEmployed(selectedOccupations, [59, 60, 61]));
  }, [selectedOccupations]);

  return (
    <FormGroup legendText="OCUPAÇÃO" className="section-header">
      {selectedOccupations && (
        <fieldset className="bx--fieldset">
          <legend className="bx--label required">14. Ocupação actual</legend>
          <p>
            Escolhe as opções que melhor descrevem a tua condição actual ou
            quais das opções seguintes melhor descrevem a tua situação actual:
          </p>

          <Row>
            <Column sm={12} md={12} lg={12}>
              {occupations.map((x) => (
                <DynamicCheckbox
                  key={"occ" + x.id}
                  id={x.id}
                  disabled={disabled}
                  label={x.description}
                  updateItems={updateOccupations}
                  setHasOwnBusiness={setHasOwnBusiness}
                  setIsEmployed={setIsEmployed}
                  selectedOccupations={selectedOccupations}
                  checked={isCandidatureOptionChecked(
                    selectedOccupations,
                    x.id
                  )}
                />
              ))}
            </Column>
          </Row>
        </fieldset>
      )}
    </FormGroup>
  );
};

CurrentOccupationForm.defaultProps = {
  disabled: false,
};

export default CurrentOccupationForm;
